import { render, staticRenderFns } from "./mc-serving-lines.vue?vue&type=template&id=28509d93&scoped=true"
import script from "./mc-serving-lines.vue?vue&type=script&lang=ts"
export * from "./mc-serving-lines.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28509d93",
  null
  
)

export default component.exports